module.exports = __webpack_public_path__ + "static/img/fa-brands-400.8f8fac6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fa-brands-400.svg
// module id = ofnc
// module chunks = 1